var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoNoTextDark = function SvgLogoNoTextDark(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 1200,
    viewBox: "0 0 1200 1200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_895_6809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M768.859 556.891H431.219V643.121H768.859V556.891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 0C268.63 0 0 268.63 0 600C0 931.37 268.63 1200 600 1200C931.37 1200 1200 931.37 1200 600C1200 268.63 931.37 0 600 0ZM847.9 869.46H768.86V700.6H431.22L431.13 700.46V869.46H352.09V330.54H431.13V499.49L431.22 499.4H768.86V330.54H847.9V869.46Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_895_6809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 1200,
    fill: "white"
  })))));
};
export default SvgLogoNoTextDark;